// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** PayPal */
export const PayPal = createBankIcon({
  name: "PayPal",
  slug: "paypal",
  compe: null,
  color: "#003087",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#003087;fill-opacity:1\"\n     id=\"paypal_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0178,21.0155) scale(2.41667)\">\n    <path d=\"M 15.607,4.653 L 8.941,4.653 L 6.645,19.251 L 1.82,19.251 L 4.862,0 l 7.995,0 c 3.754,0 6.375,2.294 6.473,5.513 c -0.648,-0.478 -2.105,-0.86 -3.722,-0.86 m 6.57,5.546 c 0,3.41 -3.01,6.853 -6.958,6.853 l -2.493,0 L 11.595,24 L 6.74,24 l 1.845,-11.538 l 3.592,0 c 4.208,0 7.346,-3.634 7.153,-6.949 a 5.24,5.24 0 0,1 2.848,4.686 M 9.653,5.546 l 6.408,0 c 0.907,0 1.942,0.222 2.363,0.541 c -0.195,2.741 -2.655,5.483 -6.441,5.483 L 8.714,11.57 Z\" style=\"fill:#ffffff\" fill-rule=\"evenodd\" />\n  </g>",
});
